import { useEffect, useMemo } from 'react'

import { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'
import { useIntl } from 'react-intl'

import MobileBottomNavigationWrapper from 'components/organisms/mobileBottomNavigationWrapper'
import { NavigatorLayout } from 'components/templates/navigatorLayout'
import { useRouterExtend } from 'hooks/useRouterExtend'
import {
  BabyPoopPage as BabyPoopPageType,
  FooterInfo,
  LOCALE,
} from 'interfaces/types'

import { BabyPoopDetail } from './detail'
import { StyledBabyPoop } from './index.styled'
import { BabyPoopIntroduce } from './introduce'
import { BABY_POOP_PAGE_TYPE } from './types'
import { addResultToLink } from '../helpers'

export type Props = {
  pageType: string
  content: {
    title: string
    description: string
  }[]
  babyPoopPage: BabyPoopPageType
  isMobileSsr: boolean
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
}

const BabyPoopPage = ({
  footerInfo,
  dataNavMenuContent,
  babyPoopPage,
}: Props) => {
  const { locale = 'en-PH', query, router } = useRouterExtend()
  const { formatMessage: f } = useIntl()

  const babyPoopPageType = useMemo<
    typeof BABY_POOP_PAGE_TYPE[keyof typeof BABY_POOP_PAGE_TYPE]
  >(() => {
    if (
      query.type &&
      babyPoopPage.result.find((poop) => query.type === poop.name)
    ) {
      return BABY_POOP_PAGE_TYPE.DETAIL
    } else {
      return BABY_POOP_PAGE_TYPE.INTRO
    }
  }, [locale, router.asPath])

  const isDetailPage = babyPoopPageType === BABY_POOP_PAGE_TYPE.DETAIL
  const isVN = locale === LOCALE.Vietnam

  useEffect(() => {
    if (babyPoopPageType === BABY_POOP_PAGE_TYPE.DETAIL) {
      if (!router.asPath.includes('?result=1')) {
        const newPath = addResultToLink(router.asPath)
        router.push(newPath, newPath, { shallow: true })
      }
    }
  }, [babyPoopPageType])

  return (
    <>
      <NavigatorLayout
        description={f({
          id: 'babyPoop.description',
        })}
        SEOData={{
          schemaData: f({
            id: 'babyPoop.seoTitle',
          }),
          apiMetaData: babyPoopPage.metaTag,
          isIndexable: true,
          hasNoCanonical: true,
        }}
        footerInfo={footerInfo}
        dataNavMenuContent={dataNavMenuContent}
        activeMenuService="tools"
        isSponsored={babyPoopPage.isSponsored}
        sponsoredBy={babyPoopPage.sponsor ? babyPoopPage.sponsor : undefined}
        sponsoredType="content"
      >
        <StyledBabyPoop>
          {babyPoopPageType === BABY_POOP_PAGE_TYPE.INTRO && (
            <BabyPoopIntroduce isVN={isVN} babyPoopPage={babyPoopPage} />
          )}

          {isDetailPage && (
            <BabyPoopDetail isVN={isVN} babyPoopPage={babyPoopPage} />
          )}
        </StyledBabyPoop>
      </NavigatorLayout>
      <MobileBottomNavigationWrapper.FitnessHealthTool appTool="baby-growth" />
    </>
  )
}

export { BabyPoopPage }
